<template>
    <div class="quantity-picker-wrapper">
        <p v-if="label" class="quantity-label"> {{ label }} </p>
        <div class="item-counter">
            <i class="prz-minus" @click.stop="qtyDec"/>
            <div class="item-qty">
                {{ selected.toString().padStart(2, "0") }}
            </div>
            <i class="prz-plus" @click.stop="qtyInc"/>
        </div>
    </div>
</template>

<script>

import {storePdp} from '@/store/product-page';


export default {
    storePdp,
    name: 'QuantityPicker',
    components: {},
    props: {
        label: {
            type: String,
            default: ''
        },
        defaultQty: {
            type: Number,
            default: 1,
        },
        qtyMinLimit: {
            type: Number,
            default: 1,
        },
        qtyLimit: {
            type: Number,
            default: 5,
        },
        itemIndex: { // for multiple widgets
            type: [Number, String],
            default: 0,
        },
    },
    data() {
        return {
            //selected: this.defaultQty > 1 ? this.defaultQty : 1,
            selected: 1,
        }
    },
    computed: {
        /*groupId() {
            return storePdp.getters.GroupId;
        },*/
        selectedProduct() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/selectedProduct'];
        },
    },
    watch: {
        defaultQty(value) {
            if(value) {
                this.selected = this.defaultQty;
                this.triggerUpdate();
            }
        },
        /*groupId(value) {
            if(value) {
                this.selected = 1;
                this.triggerUpdate();
            }
        },*/
        selectedProduct(value) {
            if(this.defaultQty == 1 && (value && value.sku)) {
                this.selected = 1;
                this.triggerUpdate();
            }
        }
    },
    created() {
    },
    mounted() {
       /* this.$nextTick(() => {
            if(this.selected > 1) {
                this.triggerUpdate();
            }
        });*/
    },
    methods: {
        qtyDec() {
            if(this.selected > this.qtyMinLimit){
                this.selected--;
                this.triggerUpdate();
            }
        },
        qtyInc() {
            if(this.selected < this.qtyLimit){
                this.selected++;
                this.triggerUpdate();
            }
        },
        triggerUpdate() {
            this.$emit('input', this.selected);
            storePdp.dispatch('pdpDesktop/addToCartDesktop/updateCartItemQty', this.selected);
        }
    }
};
</script>

<style lang="scss">
@import "../styles/quantityPicker";
</style>